module.exports = __webpack_public_path__ + "static/img/strona_055.844b602b.jpg";